import apiClient from './client'

/**
 * 邀请相关 API
 */
export const invitationApi = {
  /**
   * 获取积分订单列表
   * @param {string} userId - 用户ID
   * @returns {Promise} 积分订单列表响应
   */
  getScoreOrder(userId) {
    return apiClient.get(`/get_score_order/${userId}`)
  },

  /**
   * 获取邀请积分
   * @param {string} userId - 用户ID
   * @returns {Promise} 邀请积分响应
   */
  getInvitationScore(userId) {
    return apiClient.get(`/get-invitation-score/${userId}`)
  }
}
